<div class="usage-forecast-container" *transloco="let t; prefix: 'parts.forecast'">
  <div class="usage-forecast-header">
    <h3 class="usage-forecast-title">{{ t('title') }}</h3>
  </div>

  @if (isLoading) {
  <div class="loading-container">
    <div class="spinner-border" role="status">
      <span class="visually-hidden">{{ t('loading') }}</span>
    </div>
  </div>
  }

  @if (!isLoading) {
  <div
    class="usage-forecast-list"
    infiniteScroll
    [scrollWindow]="false"
    (scrolled)="onScrollDown()"
    [infiniteScrollDistance]="2"
    [infiniteScrollThrottle]="300">
    @for (item of usageForecastItems; track $index) {
    <div class="usage-forecast-card">
      <!-- First div: part info (left) + reorder date badge (right) -->
      <div class="card-top">
        <div class="part-info">
          <span class="part-number">{{ item.partNumber }}</span>
          <span class="part-name">{{ item.partName }}</span>
        </div>
        <div class="reorder-badge">
          <span class="reorder-label">{{ t('reorderLabel') }} {{ item.reorderDate | date }}</span>
        </div>
      </div>

      <!-- Second div: estimated cost -->
      <div class="cost-section">
        <span class="cost-label">{{ t('estCost') }}</span>
        <span class="cost-value">{{ t('estCostValue', { cost: item.estimatedCost | number }) }}</span>
      </div>

      <!-- Third div: suggested reorder pill + stats -->
      <div class="forecast-details">
        <div class="reorder-suggestion">
          <span class="suggestion-text">{{ t('suggestedReorder', { count: item.suggestedReorder }) }}</span>
        </div>

        <div class="stats-row">
          <div class="stat-item">
            <span class="stat-label">{{ t('onHand') }}</span>
            <span class="stat-value">{{ item.onHand }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">{{ t('avgMonthlyUsage') }}</span>
            <span class="stat-value">{{ item.avgMonthlyUsage }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">{{ t('reorderPoint') }}</span>
            <span class="stat-value">{{ item.reorderPoint }}</span>
          </div>
        </div>
      </div>
    </div>
    }

    @if (isLoadingMore) {
    <div class="loading-more">
      <span class="spinner-border spinner-border-sm" role="status">
        <span class="visually-hidden">{{ t('loading') }}</span>
      </span>
    </div>
    }

    @if (!usageForecastItems.length) {
    <div class="empty-state">
      <app-empty-state></app-empty-state>
    </div>
    }
  </div>
  }
</div>
